import Axios from "../utils/axiosInstance";

//get Custmor Name wise Report
export const getDashboardTotalCount = (fkUserId,role,headers) => {
  return Axios.get(
    // `petrotec/getTotalCount?fkUserId=${fkUserId}&role=${role}`,{headers}
      `/User/getTotalCount?fkUserId=${fkUserId}&role=${role}`,{headers}
  );
};